import { useTranslation } from 'react-i18next'
import Logo from './Logo'
import NavMenuLinks from './NavMenuLinks'
import HeaderMenuButton from './HeaderMenuButton'
import { useHeaderMenu } from './useHeaderMenu'
import './headerShared.css'
import './HeaderCentered.css'

function HeaderCentered({ brand, headerNav }) {
  const { t } = useTranslation()
  const { menuOpen, navItems, getLabel, closeMenu, toggleMenu } = useHeaderMenu(headerNav)

  return (
    <header className="header header--centered">
      <div className="header__container">
        <div className="header__top">
          <Logo brand={brand} className="logo--centered" />
          <HeaderMenuButton
            open={menuOpen}
            onClick={toggleMenu}
            labelOpen={t('header.openMenu')}
            labelClose={t('header.closeMenu')}
          />
        </div>
        {navItems.length > 0 ? (
          <nav className={`header__nav ${menuOpen ? 'header__nav--open' : ''}`} aria-label={t('header.mainNav')}>
            <NavMenuLinks items={navItems} getLabel={getLabel} onNavigate={closeMenu} />
          </nav>
        ) : null}
      </div>
    </header>
  )
}

export default HeaderCentered
